var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "dgov2-slickslideshow",
      style: { visibility: _vm.visibility },
      attrs: { "unique-id": _vm.uniqueId },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }